import styled, { css, CSSProperties } from 'styled-components';
import {
  CssUnitsAsResponsiveObject,
  getCssRuleWithResponsiveCalculation,
} from '../../utils/get-css-rule-with-responsive-calc';
import { withSpacing } from '../../utils';
import { borderRadiusConstants } from './style';

export interface ImageProps {
  borderRadius?: keyof typeof borderRadiusConstants;
  objectFit?: CSSProperties['objectFit'];
  objectPosition?: CSSProperties['objectPosition'];
  width?: number | string;
  height?: number | string;
  src: string | null;
  alt: string;
  alignSelf?: CSSProperties['alignSelf'];
  responsiveHeight?: CssUnitsAsResponsiveObject<string>;
  maxWidth?: CSSProperties['maxWidth'];
  maxHeight?: CSSProperties['maxHeight'];
  aspectRatio?: CSSProperties['aspectRatio'];
}

const Image = styled.img<ImageProps>`
  ${withSpacing};

  ${props =>
    props.width &&
    css`
      width: ${typeof props.width === 'number' ? `${props.width}px` : props.width};
    `}

  ${props =>
    props.borderRadius &&
    css`
      border-radius: ${borderRadiusConstants[props.borderRadius]};
    `}

  ${props =>
    props.objectFit &&
    css`
      object-fit: ${props.objectFit};
    `}

  ${props =>
    props.objectPosition &&
    css`
      object-position: ${props.objectPosition};
    `}

  ${props =>
    props.alignSelf &&
    css`
      align-self: ${props.alignSelf};
    `}

    ${props =>
    props.height &&
    css`
      height: ${typeof props.height === 'number' ? `${props.height}px` : props.height};
    `}


  ${props =>
    props.maxWidth &&
    css`
      max-width: ${typeof props.maxWidth === 'number' ? `${props.maxWidth}px` : props.maxWidth};
    `}
  ${props =>
    props.maxHeight &&
    css`
      max-height: ${typeof props.maxHeight === 'number' ? `${props.maxHeight}px` : props.maxHeight};
    `}
  ${props =>
    props.aspectRatio &&
    css`
      aspect-ratio: ${props.aspectRatio};
    `}

  ${props =>
    getCssRuleWithResponsiveCalculation<ImageProps['responsiveHeight']>({
      property: 'height',
      value: props.responsiveHeight,
    })};
`;

export default Image;
